const LoadingButton = (props: {
  isLoading: boolean;
  isProductTile?: boolean;
  buttonText: string;
  buttonIcon?: JSX.Element;
  isDisabled?: boolean;
  className?: string;
  onClick?: () => void;
}) => {
  const click = () => {
    if (props?.onClick) return props?.onClick?.();
  };

  return (
    <button
      type="button"
      className={`${props.className} px-5 py-3 flex text-white 
      bg-secondary-cornflowerblue-600 border border-secondary-cornflowerblue-600 
      disabled:bg-slate-400 disabled:border-slate-400 disabled:text-white disabled:cursor-not-allowed 
      hover:text-primary-blue-500 hover:bg-white font-semibold rounded-lg text-sm justify-center ${props.isProductTile ? 'relative w-[105%] left-[-1px] bottom-[-1px]' : ''}`}
      onClick={click}
      disabled={props.isDisabled}
    >
      {props.isLoading ? (
        <svg className="animate-spin h-5 w-5 " viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      ) : (
        props.buttonText
      )}
    </button>
  );
};

export default LoadingButton;
